import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { ArrowUp } from "react-bootstrap-icons";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="position-fixed bottom-3 end-3" style={{ zIndex: 1000 }}>
      {isVisible && (
        <Button
          onClick={scrollToTop}
          className="rounded-circle shadow-lg scrollorange"
          style={{
            width: "50px",
            height: "50px",
            position: "fixed",
            bottom: "20px",
            right: "20px",
          }}
        >
          <ArrowUp size={24} />
        </Button>
      )}
    </div>
  );
};

export default ScrollToTop;
